// development
// export const ARCHIVE_SERVER_PATH = 'http://localhost:3003';

// production
export const ARCHIVE_SERVER_PATH = 'https://archive-server.tattle.co.in';